var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCircleHelp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.09766 6.54908C6.21152 6.19822 6.4201 5.88597 6.70052 5.64632C6.98094 5.40667 7.32253 5.24919 7.68685 5.19139C8.05117 5.13358 8.42415 5.1776 8.76497 5.31868C9.1058 5.45977 9.40097 5.6925 9.61784 5.99089C9.83471 6.28927 9.96459 6.64171 9.99358 7.00944C10.0226 7.37717 9.94923 7.74586 9.78179 8.07454C9.61436 8.40323 9.35958 8.67899 9.04507 8.87174C8.73056 9.0645 8.36888 9.16651 8 9.16651V9.83349M8 14.5C4.68629 14.5 2 11.8137 2 8.5C2 5.18629 4.68629 2.5 8 2.5C11.3137 2.5 14 5.18629 14 8.5C14 11.8137 11.3137 14.5 8 14.5ZM8.0332 11.8333V11.9L7.9668 11.9001V11.8333H8.0332Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCircleHelp);
export default __webpack_public_path__ + "static/media/circle_help.15c6d46395d034a887ae2fc27f168e00.svg";
export { ForwardRef as ReactComponent };